// export function validaDocumento (strCPF) {
//   let Soma
//   let Resto
//   Soma = 0
//   strCPF = strCPF.replace(/\D/g, '')
//   let invalids = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '99999999999']
//
//   if (invalids.indexOf(strCPF) !== -1) {
//     return false
//   }
//
//   if (strCPF === '00000000000') return false
//
//   let i
//   for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i)
//   Resto = (Soma * 10) % 11
//
//   if ((Resto === 10) || (Resto === 11)) Resto = 0
//   if (Resto !== parseInt(strCPF.substring(9, 10))) return false
//
//   Soma = 0
//   for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i)
//   Resto = (Soma * 10) % 11
//
//   if ((Resto === 10) || (Resto === 11)) Resto = 0
//   if (Resto !== parseInt(strCPF.substring(10, 11))) return false
//   return true
// }

import {isInteger} from 'lodash'

export function isValidDate (str, lang = 'en') {
  if (lang === 'pt-br') {
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
      return false
    }
    let date = str.split('/')
    let newDate = date['2'] + '-' + date[1] + '-' + date[0]
    return !!new Date(newDate).getTime()
  }
  return !!new Date(str).getTime()
}

export function validaDocumento (documento) {
  console.log('documento', documento)
  if (!isInteger(documento)) {
    documento = documento.replace(/[^\d]+/g, '') // Remove caracteres não numéricos
  }

  if (documento.length === 11) {
    return validaCpf(documento)
  } else if (documento.length === 14) {
    return validaCNPJ(documento)
  } else {
    return false
  }
}

function validaCpf (cpf) {
  if (!isInteger(cpf)) {
    cpf = cpf.replace(/[^\d]+/g, '') // Remove caracteres não numéricos
  }

  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
    return false // Verifica se tem 11 dígitos ou se todos os dígitos são iguais
  }

  let soma = 0
  let resto

  for (let i = 1; i <= 9; i++) {
    soma += parseInt(cpf.substring(i - 1, i)) * (11 - i)
  }

  resto = (soma * 10) % 11

  if (resto === 10 || resto === 11) {
    resto = 0
  }

  if (resto !== parseInt(cpf.substring(9, 10))) {
    return false
  }

  soma = 0
  for (let i = 1; i <= 10; i++) {
    soma += parseInt(cpf.substring(i - 1, i)) * (12 - i)
  }

  resto = (soma * 10) % 11

  if (resto === 10 || resto === 11) {
    resto = 0
  }

  if (resto !== parseInt(cpf.substring(10, 11))) {
    return false
  }

  return true
}

function validaCNPJ (cnpj) {
  if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) {
    return false // Verifica se tem 14 dígitos ou se todos os dígitos são iguais
  }

  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0, tamanho)
  let digitos = cnpj.substring(tamanho)
  let soma = 0
  let pos = tamanho - 7

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) {
      pos = 9
    }
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado !== parseInt(digitos.charAt(0))) {
    return false
  }

  tamanho = tamanho + 1
  numeros = cnpj.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) {
      pos = 9
    }
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado !== parseInt(digitos.charAt(1))) {
    return false
  }

  return true
}



// WEBPACK FOOTER //
// ./src/utils/helpers/validators.js